import GATSBY_COMPILED_MDX from "/opt/build/repo/src/flowgallery/flowgallery/professional/industrial_design_bottle.md";
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import {graphql} from 'gatsby';
import {getImage} from 'gatsby-plugin-image';
import {ScrollTrigger, TextPlugin, gsap} from 'gsap/all';
import React from 'react';
import {FlowGalleryDetail} from '../components/FlowGallery/FlowGalleryDetail';
dayjs.extend(relativeTime);
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(TextPlugin);
const FlowGalleryDetailPage = ({data, pageContext: {slug}, children}) => {
  const {frontmatter: {title, author, affiliation, author_url, date, description, gallery_images, tags, cover}} = data.mdx;
  const coverImage = gallery_images[0];
  const images = gallery_images.map(i => {
    return getImage(i);
  });
  const formattedDate = dayjs(date).fromNow();
  return React.createElement(FlowGalleryDetail, {
    slug: slug,
    title: title,
    author: author,
    affiliation: affiliation,
    authorUrl: author_url,
    date: formattedDate,
    description: description,
    images: images,
    tags: tags,
    cover: cover ? cover.childImageSharp.resize : coverImage.childImageSharp.resize
  }, children);
};
FlowGalleryDetailPage
export default function GatsbyMDXWrapper(props) {
  return React.createElement(FlowGalleryDetailPage, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const pageQuery = graphql`
  query FlowGalleryDetail($slug: String!) {
    mdx(fields: { slug: { eq: $slug } }) {
      frontmatter {
        title
        author
        affiliation {
          title
          url
        }
        author_url
        date
        description
        gallery_images {
          childImageSharp {
            ...flowGalleryImage
          }
        }
        tags
        cover {
          childImageSharp {
            resize(width: 800, quality: 90, toFormat: PNG) {
              src
              width
              height
            }
          }
        }
      }
    }
  }
`;
